export enum VriChatMessageStatus {
  PENDING = 'pending',
  DELIVERED = 'delivered',
  READ = 'read',
}
